import '@core/scss/template/libs/vuetify/index.scss';
import { createVuetify } from 'vuetify';
import { VBtn } from 'vuetify/components/VBtn';
import 'vuetify/styles';

import defaults from './defaults';
import { icons } from './icons';
import theme from './theme';
// Styles

export default createVuetify({
  aliases: {
    IconBtn: VBtn,
  },
  defaults,
  icons,
  theme,
});
